module.exports = __webpack_public_path__ + "img/2.989ef602.jpg";